import { createReducer, on } from '@ngrx/store';
import {
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_LOGIN_SERVICE_SUCCESS,
  AUTHENTICATION_SUCCESS,
  AUTHENTICATION_RESET,
  AUTHENTICATION_RESET_FORM,
  AUTHENTICATION_CREDENTIAL_RESET,
  AUTHENTICATION_RESET_ERROR,
  AUTHENTICATION_UPDATE_FORM,
  AUTHENTICATION_UPDATE_CREDENTIAL,
  AUTHENTICATION_CREDENTIAL_SELECTED,
  AUTHENTICATION_FORGOT_PASSWORD_SUCCESS,
  AUTHENTICATION_CHANGE_PASSWORD_SUCCESS,
  AUTHENTICATION_UPDATE_FORGOT_PASSWORD_FORM,
  AUTHENTICATION_UPDATE_CHANGE_PASSWORD_FORM,
  AUTHENTICATION_RESET_FORGOT_PASSWORD,
  AUTHENTICATION_RESET_FORGOT_PASSWORD_FORM,
  AUTHENTICATION_RESET_CHANGE_PASSWORD,
  AUTHENTICATION_RESET_CHANGE_PASSWORD_FORM,
  AUTHENTICATION_UPDATE_LOADING,
  AUTHENTICATION_CLEAR_STATE,
} from '../actions';
import { ResponseBadRequest, Response } from '@core/interfaces';
import {
  Credential,
  Authentication,
  AuthenticationForm,
} from '@core/models';
import { transformAuthenticationData } from '@core/helpers/authentication/authentication-mapper';
import { ResetPasswordForm } from '@core/models';
import { ChangePassword } from '@core/services/auth/interfaces/reset-password';

export interface AuthenticationState {
  loading: boolean;
  credential: Credential | null;
  authentication: Authentication | null;
  authenticationForm: AuthenticationForm | null;
  forgotPassword: Response | null;
  forgotPasswordForm: ResetPasswordForm | null;
  changePassword: Response | null;
  changePasswordForm: ChangePassword | null;
  error: ResponseBadRequest | null;
}

export const initialState: AuthenticationState = {
  loading: false,
  credential: null,
  authentication: null,
  authenticationForm: null,
  forgotPassword: null,
  forgotPasswordForm: null,
  changePassword: null,
  changePasswordForm: null,
  error: null,
};

export const authenticationReducer = createReducer(
  initialState,
  on(AUTHENTICATION_SUCCESS, (state, { authentication }) => ({ ...state, ...transformAuthenticationData(authentication) })),
  on(AUTHENTICATION_FORGOT_PASSWORD_SUCCESS, (state, { forgotPassword }) => ({ ...state, forgotPassword })),
  on(AUTHENTICATION_CHANGE_PASSWORD_SUCCESS, (state, { changePassword }) => ({ ...state, changePassword })),
  on(AUTHENTICATION_FAILURE, (state, { error }) => ({ ...state, error })),
  on(AUTHENTICATION_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(AUTHENTICATION_UPDATE_CREDENTIAL, (state, { credential }) => ({ ...state, credential: { ...state.credential, ...credential } })),
  on(AUTHENTICATION_UPDATE_FORM, (state, { authenticationForm }) => ({ ...state, authenticationForm })),
  on(AUTHENTICATION_UPDATE_FORGOT_PASSWORD_FORM, (state, { forgotPasswordForm }) => ({ ...state, forgotPasswordForm })),
  on(AUTHENTICATION_UPDATE_CHANGE_PASSWORD_FORM, (state, { changePasswordForm }) => ({ ...state, changePasswordForm })),
  on(AUTHENTICATION_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(AUTHENTICATION_CREDENTIAL_RESET, (state) => ({ ...state, credential: null, loading: false })),
  on(AUTHENTICATION_CREDENTIAL_SELECTED, (state, { credential: { apiKey, idCuenta, nombre } }) => 
    ({ ...state, credential: { ...state.credential, apiKey, idCuenta, nombreCuenta: nombre } })
  ),
  on(AUTHENTICATION_RESET, (state) => ({ ...state, authentication: null })),
  on(AUTHENTICATION_RESET_FORM, (state) => ({ ...state, authenticationForm: null, loading: false })),
  on(AUTHENTICATION_LOGIN_SERVICE_SUCCESS, (state, { loading }) => ({ ...state, loading })),
  on(AUTHENTICATION_RESET_FORGOT_PASSWORD, (state) => ({ ...state, forgotPassword: null })),
  on(AUTHENTICATION_RESET_FORGOT_PASSWORD_FORM, (state) => ({ ...state, forgotPasswordForm: null })),
  on(AUTHENTICATION_RESET_CHANGE_PASSWORD, (state) => ({ ...state, changePassword: null })),
  on(AUTHENTICATION_RESET_CHANGE_PASSWORD_FORM, (state) => ({ ...state, changePasswordForm: null })),
  on(AUTHENTICATION_CLEAR_STATE, () => initialState),
);